import React from 'react';
import { BringzzText } from "@bringzz/components";
import { useTranslation } from 'react-i18next';

const SearchFooter = () => {
    const { t } = useTranslation();
    return (
        <div className='bg-white m-2 px-4 pt-8 rounded-xl'>
            <BringzzText tag='h5' className='font-normal'>{t('component.search.footer.description')}</BringzzText>
            <div className='text-center py-4'>
                <BringzzText tag='h1'>Bringzz</BringzzText>
                <BringzzText tag='h4' className='font-normal'>{t('component.search.footer.copyright', { year: '2023' })}</BringzzText>
            </div>
        </div>
    );
};

export default SearchFooter;